import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

window._ = require('lodash')
window.axios = require('axios')

window.Vue = Vue

Vue.config.productionTip = false

// register globally
Vue.component('multiselect', Multiselect)

Vue.filter('number', value => (value || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))
Vue.filter('rounded_number', value => Vue.filter('number')(value).replace(/\..*/, ''))
Vue.filter('currency', value => STOCKED.selected_currency + Number(value || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))
Vue.filter('rounded_currency', value => STOCKED.selected_currency + (value || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\..*/, ''))
Vue.filter('to_percentage', (value) => {
  let percentage = Math.round((value || 0) * 100 * 100) / 100
  if (percentage == 0) {
    percentage = '<0.01'
  }
  return `${percentage}%`
})

Vue.use({
  install(VueConstructor, _options) {
    global.STOCKED = {
      all_countries: [],
      all_sectors: [],
      selected_currency: (localStorage.getItem('selected_currency') || '$'),
      all_holdings: [],
      portfolio_size: 0
    }
    VueConstructor.prototype.STOCKED = global.STOCKED
  },
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
